var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-button",on:{"click":_vm.toggleChat}},[_c('b-icon',{staticClass:"icon",attrs:{"icon":"messenger"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }